'use client';

import React, { useState } from 'react';
import { useRouter } from 'next/navigation';
import {
  RequestMagicLinkForm,
  type FeedbackMessageBannerProps,
  type RequestMagicLinkFormValues,
} from '@clara/ui';
import { authClient } from '../../../../lib/auth/auth-client';

const REQUEST_FAILED = 'Internal server error occurred';

export const RequestMagicLinkPage: React.FC = () => {
  const router = useRouter();

  const [banner, setBanner] = useState<Pick<FeedbackMessageBannerProps, 'variant' | 'message'>>({
    variant: 'info',
    message: "Enter your email address and we'll send you a link that'll sign you in instantly.",
  });

  const onSubmit = async (data: RequestMagicLinkFormValues) => {
    setBanner({
      variant: 'info',
      message: "Enter your email address and we'll send you a link that'll sign you in instantly.",
    });

    try {
      const result = await authClient.signIn.magicLink({
        email: data.email.trim(),
        callbackURL: '/',
        errorCallbackURL: '/login?error=invalid_token',
      });

      if (result?.error) {
        setBanner({ variant: 'error', message: REQUEST_FAILED });
        return;
      }

      router.push('/request-magic-link/success');
    } catch {
      setBanner({ variant: 'error', message: REQUEST_FAILED });
    }
  };

  return <RequestMagicLinkForm onSubmit={onSubmit} banner={banner} />;
};

